// src/utils/tokenUtils.js
export const isTokenExpired = (token) => {
  if (!token) return true;
  
  try {
    const decoded = JSON.parse(atob(token.split('.')[1]));
    const currentTime = Math.floor(Date.now() / 1000);
    // Add 30 second buffer to account for network delays
    return decoded.exp < (currentTime + 30);
  } catch (error) {
    console.error('Error decoding token:', error);
    return true;
  }
};

export const clearAllTokens = () => {
  sessionStorage.removeItem("idToken");
  sessionStorage.removeItem("accessToken");
  localStorage.removeItem("idToken");
};

export const getTokenExpiryTime = (token) => {
  if (!token) return null;
  try {
    const decoded = JSON.parse(atob(token.split('.')[1]));
    return decoded.exp * 1000; // Convert to milliseconds
  } catch (error) {
    return null;
  }
};
// In tokenUtils.js — ADD this new function

/**
 * Checks if the current access token is still accepted by Cognito.
 * Returns false if admin has signed out the user from the console.
 */
export const isTokenRevokedByCognito = async () => {
  const accessToken = sessionStorage.getItem("accessToken");
  if (!accessToken) return true; // no token = treat as revoked

  try {
    // Cognito's /oauth2/userInfo endpoint validates the access token live
    const region = sessionStorage.getItem("userRegion") || "AP";
    const domain =
      "https://ap-southeast-23poclxu4s.auth.ap-southeast-2.amazoncognito.com";

    const response = await fetch(`${domain}/oauth2/userInfo`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });

    if (response.status === 401 || response.status === 400) {
      console.log("🔴 Token revoked or invalid — admin may have signed out user");
      return true; // token is revoked
    }

    return false; // token is still valid
  } catch (err) {
    console.error("Token revocation check failed:", err);
    return false; // network error — don't log out
  }
};